<template>
  <div class="news mt-h">
    <div v-if="showLoading" class="showLoading">
      <img src="@/assets/imgs/loading.gif" alt="" width="300" height="210">
    </div>
    <div v-else> 
    <NewsTitle :pT='pT' :cT='cT'></NewsTitle>
    <NewsList :searchData='searchData' ref="newList"></NewsList>
    <BackTop></BackTop>
    <Footer></Footer>
    </div>

  </div>
</template>

<script>
import NewsTitle from "./newschild/NewsTitle";
import NewsList from "./newschild/NewsList";

import Footer from "@/components/common/layout/Footer.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";
import { getSearch } from "@/network/details.js";
export default {
  name: "News",
  components: {
    NewsTitle,
    NewsList,
    Footer,
    BackTop,
  },
  data() {
    return {
      pT: "",
      cT: "",
      searchData: [],
      loading: true,
      page: 1,
      showLoading:"true"
    };
  },
  mounted() {
    this.pT = this.$route.query.pT;
    this.cT = this.$route.query.cT;
    document.title = this.cT + " | ShanghaiEye";
    this.searchFn();
    document.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadMore);
  },
  methods: {
    searchFn() {
      getSearch({ classification: this.cT, page: this.page, size: 9 })
        .then(res => {
          this.searchData = this.searchData.concat(res.data);
          this.loading = true;
          this.showLoading = false
        })
        .catch(res => {
          this.loading = true;
        });
    },
    //滚动到底部加载更多
    load() {
      if (this.loading) {
        this.loading = false;
        setTimeout(() => {
          this.page++; // 加载更多是definePageNum+1
          this.searchFn();
          this.$refs.newList.handelWidth();
        }, 100);
      }
    },
    //触发滚动
    loadMore() {
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
      let nowScotop =
        document.documentElement.clientHeight || document.body.clientHeight; //可视区高度
      let wheight =
        document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度
      // console.log(nowScotop,'----',scrollHeight - wheight - 200,'height')
      if (this.loading) {
        if (nowScotop >= scrollHeight - wheight - 200) {
          setTimeout(() => {
            this.load(); //加载列表的请求方法
          }, 100);
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less" scoped>
.news {
  height: 100%;
  overflow-x: hidden;
}
</style>